export default "__VITE_ASSET__DxdrCZd2__"